const states = [
  { id: 0, value: 'AL', longValue: 'Alabama', label: 'AL' },
  { id: 1, value: 'AK', longValue: 'Alaska', label: 'AK' },
  { id: 2, value: 'AZ', longValue: 'Arizona', label: 'AZ' },
  { id: 3, value: 'AR', longValue: 'Arkansas', label: 'AR' },
  { id: 4, value: 'CA', longValue: 'California', label: 'CA' },
  { id: 5, value: 'CO', longValue: 'Colorado', label: 'CO' },
  { id: 6, value: 'CT', longValue: 'Connecticut', label: 'CT' },
  { id: 7, value: 'DE', longValue: 'Delaware', label: 'DE' },
  { id: 8, value: 'FL', longValue: 'Florida', label: 'FL' },
  { id: 9, value: 'GA', longValue: 'Georgia', label: 'GA' },
  { id: 50, value: 'GU', longValue: 'Guam', label: 'GU' },
  { id: 10, value: 'HI', longValue: 'Hawaii', label: 'HI' },
  { id: 11, value: 'ID', longValue: 'Idaho', label: 'ID' },
  { id: 12, value: 'IL', longValue: 'Illinois', label: 'IL' },
  { id: 13, value: 'IN', longValue: 'Indiana', label: 'IN' },
  { id: 14, value: 'IA', longValue: 'Iowa', label: 'IA' },
  { id: 15, value: 'KS', longValue: 'Kansas', label: 'KS' },
  { id: 16, value: 'KY', longValue: 'Kentucky', label: 'KY' },
  { id: 17, value: 'LA', longValue: 'Louisiana', label: 'LA' },
  { id: 18, value: 'ME', longValue: 'Maine', label: 'ME' },
  { id: 19, value: 'MD', longValue: 'Maryland', label: 'MD' },
  { id: 20, value: 'MA', longValue: 'Massachusetts', label: 'MA' },
  { id: 21, value: 'MI', longValue: 'Michigan', label: 'MI' },
  { id: 22, value: 'MN', longValue: 'Minnesota', label: 'MN' },
  { id: 23, value: 'MS', longValue: 'Mississippi', label: 'MS' },
  { id: 24, value: 'MO', longValue: 'Missouri', label: 'MO' },
  { id: 25, value: 'MT', longValue: 'Montana', label: 'MT' },
  { id: 26, value: 'NE', longValue: 'Nebraska', label: 'NE' },
  { id: 27, value: 'NV', longValue: 'Nevada', label: 'NV' },
  { id: 28, value: 'NH', longValue: 'New Hampshire', label: 'NH' },
  { id: 29, value: 'NJ', longValue: 'New Jersey', label: 'NJ' },
  { id: 30, value: 'NM', longValue: 'New Mexico', label: 'NM' },
  { id: 31, value: 'NY', longValue: 'New York', label: 'NY' },
  { id: 32, value: 'NC', longValue: 'North Carolina', label: 'NC' },
  { id: 33, value: 'ND', longValue: 'North Dakota', label: 'ND' },
  { id: 34, value: 'OH', longValue: 'Ohio', label: 'OH' },
  { id: 35, value: 'OK', longValue: 'Oklahoma', label: 'OK' },
  { id: 36, value: 'OR', longValue: 'Oregon', label: 'OR' },
  { id: 37, value: 'PA', longValue: 'Pennsylvania', label: 'PA' },
  { id: 38, value: 'RI', longValue: 'Rhode Island', label: 'RI' },
  { id: 39, value: 'SC', longValue: 'South Carolina', label: 'SC' },
  { id: 40, value: 'SD', longValue: 'South Dakota', label: 'SD' },
  { id: 41, value: 'TN', longValue: 'Tennessee', label: 'TN' },
  { id: 42, value: 'TX', longValue: 'Texas', label: 'TX' },
  { id: 43, value: 'UT', longValue: 'Utah', label: 'UT' },
  { id: 44, value: 'VT', longValue: 'Vermont', label: 'VT' },
  { id: 45, value: 'VA', longValue: 'Virginia', label: 'VA' },
  { id: 46, value: 'WA', longValue: 'Washington', label: 'WA' },
  { id: 47, value: 'WV', longValue: 'West Virginia', label: 'WV' },
  { id: 48, value: 'WI', longValue: 'Wisconsin', label: 'WI' },
  { id: 49, value: 'WY', longValue: 'Wyoming', label: 'WY' },
];

export default states;

